import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';

import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TableRowCollapsible from './TableRowCollapsible';

const useStyles = makeStyles({
  container: {
    marginTop: 5
  },
  table: {
    minWidth: '100%'
  },
  trashIcon: {
    cursor: 'pointer'
  }
});

const TableCellTitleStrong = withStyles((theme) => ({
  head: {
    fontSize: 14,
    fontWeight: 'bold',
    borderBottom: 'none !important'
  }
}))(TableCell);

const OrdersSavedTable = ({ orders, onClickDelete, onClickAmend }) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const rows = [
    {
      date: '2020-01-05',
      details: '	$10,000 representing at a unit price of XXX.',
      amount: 3
    },
    {
      date: '2020-01-02',
      details: '	$75,000 representing at a unit price of XXX.',
      amount: 1
    }
  ];

  return (
    <TableContainer className={classes.container} component={Paper}>
      <Table className={classes.table} size="small">
        <TableHead>
          <TableRow>
            <TableCellTitleStrong />
            <TableCellTitleStrong>Order ID</TableCellTitleStrong>
            <TableCellTitleStrong>Date</TableCellTitleStrong>
            <TableCellTitleStrong>Order Details</TableCellTitleStrong>
            <TableCellTitleStrong align="center">Confirm</TableCellTitleStrong>
            <TableCellTitleStrong align="center">Amend</TableCellTitleStrong>
            <TableCellTitleStrong align="center">Delete</TableCellTitleStrong>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders.map((order) => (
            <TableRowCollapsible
              key={Math.random()}
              saved
              rows={rows}
              order={order}
              onClickDelete={onClickDelete}
              onClickAmend={onClickAmend}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OrdersSavedTable;
